import { useEffect, useState } from 'react'
import { Box, Switch, Typography, useMediaQuery, useTheme } from '@mui/material'

import { ETraicyPostsPayloadFields, IUpdateTraicyPostsPayloadDto } from 'src/types'

interface IProps {
  field: ETraicyPostsPayloadFields
  value: boolean
  handleUpdate: (dto: IUpdateTraicyPostsPayloadDto) => void
  isLoading: boolean
}

export const TraicyPostImageSwitch = ({ value, handleUpdate, field, isLoading }: IProps) => {
  const [useImageChecked, setUseImageChecked] = useState<boolean>(value)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('mobile_l'))

  useEffect(() => {
    if (!isLoading) {
      setUseImageChecked(value)
    }
  }, [isLoading])

  const handleUpdateUseImage = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setUseImageChecked(checked)
    handleUpdate({
      field,
      value: checked,
    })
  }

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',

          alignItems: 'center',
          justifyContent: 'start',
          gap: '8px',
          pl: isMobile ? '15px' : '50px',
        }}
      >
        <Box sx={{}}>
          <Typography fontSize={'14px'}>{'Use Image Generation'}</Typography>
        </Box>
        <Switch
          checked={useImageChecked}
          disabled={isLoading}
          onChange={handleUpdateUseImage}
          id={'use_image' + field}
          name={'use_image' + field}
        />
      </Box>
    </>
  )
}
